export const accordionStyle = {
  backgroundColor: "#B28181",
  fontFamily: "Raleway",
  color: "white",
  "&:hover": {
    backgroundColor: "#F2AFAF",
    color: "white",
  },
  padding: "1rem",
  margin: "0.5rem 0rem",
  fontSize: "2rem",
  width: "100%",
};


export const gridStyle = {
    backgroundColor: "#B28181",
    fontFamily: "Raleway",
    color: "white",
    padding: "1rem",
    margin: "0.5rem 0rem",
    fontSize: "2rem",
    width: "100%",
    
};

export const crownsPink = "#B28181";
export const crownsPinkLight = "#F2AFAF";

